<template>
  <div class="card py-3">
    <div class="card-header p-3 pt-2">
      <div class="title-vp text-center">کد تایید</div>
      <p class="message-vp">کد دریافتی خود را وارد کنید</p>

      <div class="inputs-vp">
        <input type="text" inputmode="numeric" maxlength="4" v-model="code" @input="validateInput"
          @paste.prevent="handlePaste" @keyup.enter="submitCode" ref="codeInput"
          class="text-dark text-center w-50 mx-auto" dir="rtl" />
      </div>
      <div class="d-flex justify-content-center">
        <button class="action-vp btn bg-success text-light fw-bold w-75 rounded-3" @click.prevent="submitCode">
          تایید
        </button>
      </div>
      <div class="message-2-vp mt-2">پیامک دریافت نکردید؟</div>
      <div v-if="!isTimerFinished" class="message-2-vp">
        <div>
          بعد از <span>{{ formattedTime }}</span> دوباره امتحان کنید!
        </div>
      </div>
      <router-link v-else to="/" class="message-2-vp text-danger">
        دوباره تلاش کنید
      </router-link>
    </div>
  </div>
</template>

<script>
import { computed, ref, onMounted, onBeforeUnmount, nextTick } from "vue";
import { useLoginStore } from "@/store/loginStore";

export default {
  beforeRouteEnter(to, from, next) {
    const loginStore = useLoginStore();
    if (loginStore.error === 0) {
      next();
    } else {
      next("/");
    }
  },

  setup() {
    const code = ref(""); // آرایه‌ای برای ذخیره کد تایید
    const minute = ref(1); // دقیقه تایمر
    const sec = ref(0); // ثانیه تایمر
    const isTimerFinished = ref(false); // وضعیت اتمام تایمر
    const intervalId = ref(null); // شناسه تایمر
    const loginStore = useLoginStore();
    const codeInput = ref(null); // تعریف ref برای ورودی کد

    // فرمت زمان برای نمایش
    const formattedTime = computed(() => {
      return (
        (minute.value < 10 ? "0" : "") +
        minute.value +
        ":" +
        (sec.value < 10 ? "0" : "") +
        sec.value
      );
    });

    const startTimer = () => {
      intervalId.value = setInterval(() => {
        if (sec.value > 0) {
          sec.value--;
        } else if (minute.value > 0) {
          minute.value--;
          sec.value = 59;
        } else {
          clearInterval(intervalId.value);
          isTimerFinished.value = true;
        }
      }, 1000);
    };

    const handlePaste = (event) => {
      event.preventDefault();
      const pastedData = event.clipboardData.getData("text/plain");
      const codeArray = pastedData.split("").slice(0, 4);
      code.value = codeArray.join('');
    };

    // تابع برای ارسال کد تایید
    const submitCode = async () => {
      await loginStore.sendValidationNumber(code.value); // ارسال کد به سرور

    };

    onMounted(async () => {
      startTimer();

      // WebOTP API
      if ('OTPCredential' in window) {
        try {
          const controller = new AbortController();
          const content = await navigator.credentials.get({
            otp: { transport: ['sms'] },
            signal: controller.signal,
          });

          if (content && content.code) {
            code.value = content.code;
          }
        } catch (err) {
          console.warn("WebOTP failed:", err);
        }
      }

      await nextTick();
      if (codeInput.value) {
        codeInput.value.focus();
      }
    });


    onBeforeUnmount(() => {
      clearInterval(intervalId.value); // پاک کردن تایمر هنگام خروج
    });

    function validateInput() {
      // تبدیل اعداد فارسی به انگلیسی
      const persianToEnglishNumbers = {
        '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
        '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9'
      };

      // تبدیل ورودی به اعداد انگلیسی
      let inputValue = code.value.replace(/[۰-۹]/g, (match) => persianToEnglishNumbers[match]);

      // فقط مجاز به وارد کردن اعداد انگلیسی
      inputValue = inputValue.replace(/[^0-9]/g, "");

      // بروزرسانی مقدار ورودی
      code.value = inputValue;
    }

    return {
      formattedTime,
      isTimerFinished,
      code,
      validateInput,
      submitCode,
      handlePaste,
      codeInput, // بازگشت ref برای استفاده در template
    };
  },
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="text"] {
  text-align: right;
  /* تنظیم متن به سمت راست */
}
</style>